module.exports = __webpack_public_path__ + "img/product-tutorial-2-orange-flower.be21e55f.svg";